import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { upsertMultipleDepots } from '../depotsSlice'
import { DepotLite } from '../models/Depot'

export const fetchDepotLites = createAsyncThunk('depots/fetchDepotLites', async (_, { dispatch }) => {
  const depots = await OLMSApiService.get<DepotLite[]>('/list/depots')

  if (depots && depots.length > 0) {
    dispatch(upsertMultipleDepots(depots))
  }
})